import React, { createContext, JSX, useContext } from "react";

import { AnalyticsModalType, INITIAL_DATA, useAnalyticsModal } from "../use_analytics_modal";

const INITIAL_ANALYTICS_MODAL = {
  open: () => {},
  close: () => {},
  updateData: () => {},
  state: {
    isOpen: false,
    data: INITIAL_DATA
  }
};

const AnalyticsModalContext = createContext<AnalyticsModalType>(INITIAL_ANALYTICS_MODAL);

export const AnalyticsModalContextProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const modal = useAnalyticsModal();

  return <AnalyticsModalContext.Provider value={{ ...modal }}>{children}</AnalyticsModalContext.Provider>;
};

export const useAnalyticsModalContext = () => useContext<AnalyticsModalType>(AnalyticsModalContext);
